<template>
  <div>
    <dialog-edit :value="value" @input="$emit('input')">
      <template v-slot:title>
        <small v-if="id"> ({{ id }})</small>
        {{ id ? data.name : "Новая запись графика" }}
      </template>
      <a-form-model
        v-model="data"
        :model="model"
        :errors="errors"
        :config="{ dense: true }"
        @validate="validate($event)"
      />
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <a-btn-save v-if="editObject" @click="submit()"></a-btn-save>
        <a-btn-delete
          v-if="id && editObject"
          @click="removeDialogShow = true"
        ></a-btn-delete>
        <v-btn @click="$emit('input')">Закрыть</v-btn>
      </template>
    </dialog-edit>
    <remove-dialog v-model="removeDialogShow" @remove="remove(api, id)" />
    <su-Data
      ref="suEdit"
      v-model="suEditShow"
      :api="api"
      :id="id"
      :activate="value"
      :dataEdit="data"
      @show="suEditShow = true"
      v-if="getAccess('suData')"
    />
  </div>
</template>

<script>
import { getForm, submitForm, removeEl, getAccess } from "@/components/mixings";

export default {
  components: {
    //  usersDialog: () => import("./usersDialog2"),
  },
  mixins: [getForm, submitForm, removeEl, getAccess],
  props: {
    value: Boolean,
    id: Number,
    object_: { type: Object, default: () => {} },

    defaults: { type: Object, default: () => {} },
    lastRow: { type: Object, default: () => {} },
    workTemplate: [
      { sort: 0, name: "Демонтаж стен, перегородок, вывоз мусора", days: 5 },
      { sort: 0, name: "Монтаж стен, перегородок", days: 5 },
      { sort: 0, name: "Установка окон", days: 5 },
      { sort: 0, name: "Разводка сантехнических комуникаций", days: 5 },
      { sort: 0, name: "Утепление балкона", days: 5 },
      { sort: 0, name: "Разводка электрики", days: 5 },
      { sort: 0, name: "Закладка трасс под кондиционеры", days: 5 },
      { sort: 0, name: "Устройство теплого пола (электрического)", days: 5 },
      { sort: 0, name: "Оштукатуривание стен по маякам", days: 5 },
      { sort: 0, name: "Устройство гкл коробов, перегор, и.т.д.", days: 5 },
      { sort: 0, name: "Выравнивание полов", days: 5 },
      {
        sort: 0,
        name: "Устройство кафеля с/у (ГКЛ, гидроизоляция в с/у)",
        days: 5,
      },
      { sort: 0, name: "Устройство кафеля напольного", days: 5 },
      { sort: 0, name: "Монтаж входной двери", days: 5 },
      { sort: 0, name: "Шпаклевание стен", days: 5 },
      { sort: 0, name: "Устройство натяжных потолков", days: 5 },
      { sort: 0, name: "Потолочный плинтус, молдинги/ окраска", days: 5 },
      {
        sort: 0,
        name: "Отделка стен (окраска, сахара, обои, 3D панели и т.п)",
        days: 5,
      },
      { sort: 0, name: "Монтаж зеркал, стекол и 3D изделия", days: 5 },
      { sort: 0, name: "Монтаж напольных покрытий", days: 5 },
      { sort: 0, name: "Плинтус напольный ", days: 5 },
      { sort: 0, name: "Монтаж межкомнатных дверей", days: 5 },
      { sort: 0, name: "Установка  осветительного оборудования", days: 5 },
      { sort: 0, name: "Установка сантехнического оборудования", days: 5 },
      {
        sort: 0,
        name: "Установка корпусной мебели и кухни и мягкой мебели",
        days: 5,
      },
      { sort: 0, name: "Поставка/монтаж бытовой техники", days: 5 },
      { sort: 0, name: "Мелкие доработки после установки мебели", days: 5 },
      { sort: 0, name: "Предчистовая уборка/вывоз материалов", days: 5 },
      { sort: 0, name: "Уборка", days: 5 },
    ],
  },
  data() {
    return {
      model: this.$store.getters["config/get"].models.works.form,
      api: "/mechti/construction-schedule",
      removeDialogShow: false,
      idEdit: 0,
      suEditShow: false,
    };
  },
  computed: {
    editObject() {
      return this.getAccess("object.edit", {
        id: this.object_.id,
        access: this.object_?.object_access || [],
      });
    },
  },
  watch: {
    value() {
      if (this.value) {
        this.updateData(this.id);
      }
    },
  },
  methods: {
    afterRemove(data) {
      this.removeDialogShow = false;
      this.$emit("input");
    },
    afterSave(data, status) {
      if (status) this.$emit("input");
      // this.$router.push({name: "objects_view", params: {id: this.id}});
    },
  },
};
</script>